<app-main-navigation></app-main-navigation>
<app-price-robot-submenu></app-price-robot-submenu>

<div class="container pb-1" [ngClass]="{faded:loading}" *ngIf="competitors != null && variants != null; else spinner">
    <ng-container *ngIf="param !== '0'">
        <h1 class="mt-4">Rediger regel</h1>
    </ng-container>
    <ng-container *ngIf="param === '0'">
        <h1 class="mt-4">Tilføj ny regel</h1>
    </ng-container>

    <div class="mt-4  mb-5">
        <label for="name">Navn</label>
        <input type="text" class="ms-1" id="name" required [(ngModel)]="rule.name" name="name">
        <label for="isActive" class="ms-4">Aktiv</label>
        <input type="checkbox" class="ms-1" id="isActive" required [(ngModel)]="rule.is_active" name="isActive">
        <label for="activeStart" class="ms-4">Aktiv start</label>
        <input type="date" class="ms-1" id="activeStart" required [(ngModel)]="rule.active_start" name="activeStart">
        <label for="activeEnd" class="ms-4">Aktiv slut</label>
        <input type="date" class="ms-1" id="activeEnd" required [(ngModel)]="rule.active_end" name="activeEnd">

        <br>
        <h4 class="mt-4">Kriterier <small><a href="javascript:" (click)="addCondition()">Tilføj</a></small></h4>
        <table class="table table-bordered align-middle mt-4">
            <tr>
                <th>Konkurrent</th>
                <th>Mærke</th>
                <th>Kategori</th>
                <!--<th>Produkt</th>-->
                <!--<th>Prisændring %</th>-->
                <!--<th>% i forhold til kostpris</th>-->
                <th></th>
            </tr>

            <ng-template ngFor let-ruleCondition [ngForOf]="ruleConditions" let-i="index">
                <tr>
                    <td>
                        <ng-multiselect-dropdown
                                [placeholder]="'Vælg konkurrent'"
                                [settings]="dropdownSettings"
                                [data]="competitors"
                                [(ngModel)]="ruleCondition.competitor_id"
                                [ngModelOptions]="{standalone: true}"></ng-multiselect-dropdown>
                    </td>
                    <td>
                        <ng-multiselect-dropdown
                                [placeholder]="'Vælg mærke'"
                                [settings]="dropdownSettings"
                                [data]="variants"
                                [(ngModel)]="ruleCondition.variant_id"
                                [ngModelOptions]="{standalone: true}"></ng-multiselect-dropdown>
                    </td>
                    <td>
                        <ng-multiselect-dropdown
                                [placeholder]="'Vælg kategori'"
                                [settings]="dropdownSettings"
                                [data]="categories"
                                [(ngModel)]="ruleCondition.category_id"
                                [ngModelOptions]="{standalone: true}"></ng-multiselect-dropdown>
                    </td>
                    <!-- <td>
                         <p *ngIf="ruleCondition.product_id">{{ ruleCondition['product']['name'] }}</p>

                         <a href="javascript:" (click)="setProduct(ruleCondition)" class="me-3">Vælg</a>

                         <a *ngIf="ruleCondition.product_id" href="javascript:" (click)="ruleCondition.product_id = null;" class="text-danger">Fjern</a>
                     </td> -->
                    <!--<td><input type="text" class="form-control  form-control-sm  ms-1" [(ngModel)]="ruleCondition.price_change" name="{{ i }}-priceChange"></td>-->
                    <!--<td><input type="text" class="form-control  form-control-sm  ms-1" [(ngModel)]="ruleCondition.costprice_difference" name="{{ i }}-defaultDifference"></td>-->
                    <td>
                        <a href="javascript:" (click)="removeCondition(i)" class="text-danger">Fjern</a>
                    </td>
                </tr>
            </ng-template>
        </table>
        <br>

        <h4 class="mt-4">Handlinger <small><a href="javascript:" (click)="addAction()">Tilføj</a></small></h4>
        <table class="table table-bordered align-middle mt-4">
            <tr>
                <th>Ret pris til udregnet pris</th>
                <th>Ret pris til udsalgspris</th>
                <th>Juster crawlet pris</th>
                <!--<th>Ret pris til indtastet pris</th>-->
                <th>Afrund pris</th>
                <th>Kun overvåg</th>
                <th>Ignorer fragtpris</th>
                <th>Ignorer hvis ikke på lager</th>
                <th>Ignorer pris</th>
                <th></th>
            </tr>

            <ng-template ngFor let-ruleAction [ngForOf]="ruleActions" let-i="index">
                <tr>
                    <td>
                        <label class="form-label">
                            <input type="checkbox" class="ms-1" [(ngModel)]="ruleAction.calculated_price"
                                   name="{{ i }}-calculatedPrice">
                        </label>
                    </td>
                    <td>
                        <label class="form-label">
                            <input type="checkbox" class="ms-1" [(ngModel)]="ruleAction.discount_price"
                                   name="{{ i }}-discountPrice">
                        </label>
                    </td>
                    <td>
                        <label class="form-label">
                            <input type="text" class="form-control  form-control-sm  ms-1"
                                   [(ngModel)]="ruleAction.adjust_price" name="{{ i }}-adjustPrice">
                        </label>
                    </td>
                    <!--<td><input type="text" class="form-control  form-control-sm  ms-1" [(ngModel)]="ruleAction.custom_price" name="{{ i }}-customPrice"></td>-->

                    <td>
                        <label class="form-label">
                            <input type="radio" [(ngModel)]="ruleAction.round_price" value="0"
                                   name="{{ i }}-round_price"> Nej<br></label>
                        <label class="form-label">
                            <input type="radio" [(ngModel)]="ruleAction.round_price" value="1"
                                   name="{{ i }}-round_price"> Ja<br></label>
                        <label class="form-label">
                            <input type="radio" [(ngModel)]="ruleAction.round_price" value="5"
                                   name="{{ i }}-round_price"> Nærmeste 5</label>
                        <label class="form-label">
                            <input type="radio" [(ngModel)]="ruleAction.round_price" value="10"
                                   name="{{ i }}-round_price"> Nærmeste 10</label>
                    </td>
                    <td>
                        <label class="form-label">
                            <input type="checkbox" class="ms-1" [(ngModel)]="ruleAction.to_watch_list"
                                   name="{{ i }}-to_watch_list">
                        </label>
                    </td>
                    <td>
                        <label class="form-label">
                            <input type="checkbox" class="ms-1" [(ngModel)]="ruleAction.ignore_delivery"
                                   name="{{ i }}-ignore_delivery">
                        </label>
                    </td>
                    <td>
                        <label class="form-label">
                            <input type="checkbox" class="ms-1" [(ngModel)]="ruleAction.ignore_if_not_in_stock"
                                   name="{{ i }}-ignore_if_not_in_stock">
                        </label>
                    </td>
                    <td>
                        <label class="form-label">
                            <input type="checkbox" class="ms-1" [(ngModel)]="ruleAction.ignore_price"
                                   name="{{ i }}-ignore_price">
                        </label>
                    </td>
                    <td>
                        <a href="javascript:" (click)="removeAction(i)" class="text-danger">Fjern</a>
                    </td>
                </tr>
            </ng-template>
        </table>

        <br>


        <ng-container *ngIf="param !== '0'">
            <div class="d-flex justify-content-between">
                <div>
                    <button (click)="deleteRule()" class="btn  btn-danger  mt-4">Slet regel</button>
                    <button (click)="duplicateRule()" class="btn  btn-secondary  mt-4  ms-2">Kopier regel</button>
                </div>

                <button (click)="editRule()" class="btn  btn-primary  mt-4"
                        [disabled]="loading">{{ !loading ? 'Gem regel' : 'Gemmer...' }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="param === '0'">
            <button (click)="addRule()" class="btn  btn-primary  mt-4"
                    [disabled]="loading">{{ !loading ? 'Gem regel' : 'Gemmer...' }}
            </button>
        </ng-container>

    </div>
</div>

<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
